 export default function calcMaxVaCoLtv(creditScore){
     if (creditScore>=620){
         return 95
     }
     else return 85;
 }